import { __spreadArray } from "tslib";
import { ApolloClient, InMemoryCache, ApolloLink,
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore commonsjs module
 } from '@apollo/client';
import { createHttpLink, concatTimeoutLink, configLink, removeTypenameLink, } from './middlewares';
import VoidCache from './voidCache';
import whereami from '../../utils/whereami';
var cachedApollo;
var Client = function (_a, _b) {
    var _c = _a.cachePolicies, cachePolicies = _c === void 0 ? {} : _c, config = _a.config, configEnv = _a.configEnv, _d = _a.initialState, initialState = _d === void 0 ? {} : _d, _e = _a.linkMiddlewares, linkMiddlewares = _e === void 0 ? [] : _e, localTypeDefs = _a.localTypeDefs;
    var _f = _b === void 0 ? {} : _b, _g = _f.shouldCache, shouldCache = _g === void 0 ? true : _g;
    var newApollo = function () {
        var httpLink = createHttpLink(config);
        var timeoutLink = concatTimeoutLink(httpLink, (config === null || config === void 0 ? void 0 : config.timeout) || 1000);
        var configEnvLink = configLink(configEnv);
        var link = ApolloLink.from(__spreadArray(__spreadArray([
            configEnvLink,
            removeTypenameLink
        ], linkMiddlewares, true), [
            timeoutLink,
        ], false));
        var CacheTool = whereami.isClientSide ? InMemoryCache : VoidCache;
        var cache = new CacheTool({ typePolicies: cachePolicies }).restore(initialState);
        var serverDefaultOptions = ((config === null || config === void 0 ? void 0 : config.serverDefaultOptions) || {
            query: {
                errorPolicy: 'all',
                fetchPolicy: 'no-cache',
            },
            watchQuery: {
                errorPolicy: 'all',
                fetchPolicy: 'no-cache',
            },
        });
        return new ApolloClient({
            cache: cache,
            defaultOptions: serverDefaultOptions,
            link: link,
            typeDefs: localTypeDefs,
        });
    };
    var apollo = (shouldCache && cachedApollo) || newApollo();
    // sets cache for apollo in client
    if (whereami.isClientSide && !cachedApollo)
        cachedApollo = apollo;
    return apollo;
};
export default Client;
//# sourceMappingURL=client.js.map